import axios from 'axios';
import {
  all,
  call,
  put,
  takeEvery,
} from 'redux-saga/effects';

import {
  RESOURCES,
} from '../../libs/config';
import { exception } from '../../libs/ga';

import {
  CATALOGS,
} from './constants';

function* storeSystem(id, data) {
  yield put({
    type: CATALOGS.system,
    id,
    data,
  });
}

function* getCities() {
  try {
    const cities = yield call(() => new Promise((resolve, reject) => {
      axios.get(`${RESOURCES}/cities.json`).then((response) => {
        const {
          status, data,
        } = response;
        if (status === 200 && data) resolve(data);
        else reject(new Error(status));
      }).catch((err) => reject(err));
    }));
    yield* storeSystem('cities', cities);
  } catch (error) {
    yield* storeSystem('cities');
    exception(error);
  }
}

export default function* catalogsSaga() {
  yield all([
    yield takeEvery(CATALOGS.handlers.getCities, getCities),
  ]);
}
